import { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

// A centred dialog. Records on this platform open in the middle of the screen,
// not in a drawer off the right edge — the same shape Commercial Surveys uses,
// kept here so the next page that needs one doesn't invent a third variant.
//
// Closes on the backdrop and on Escape, and scrolls its own body so a long
// record can't push the header or the footer off the screen.
export default function Modal({
  title, subtitle, onClose, children, footer, width = 'max-w-3xl',
}) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-40 flex items-start justify-center overflow-y-auto bg-black/40 p-4 sm:p-8"
      onClick={onClose}
    >
      <div
        className={`flex max-h-full w-full ${width} flex-col overflow-hidden rounded-xl bg-gray-50 shadow-2xl`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-start justify-between gap-3 border-b border-gray-200 bg-white px-5 py-4">
          <div className="min-w-0">
            <h2 className="truncate text-lg font-bold text-gray-900">{title}</h2>
            {subtitle ? <p className="truncate text-sm text-gray-500">{subtitle}</p> : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer ? <div className="border-t border-gray-200 bg-white px-5 py-3">{footer}</div> : null}
      </div>
    </div>
  );
}
